import { render, staticRenderFns } from "./DeviceDetailCameraImage.vue?vue&type=template&id=48e66642&"
import script from "./DeviceDetailCameraImage.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailCameraImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports